export enum SerieEnum {
  infantil_3_anos = 62,
  infantil_4_anos = 63,
  infantil_5_anos = 64,
  fundamental_1_ano = 3,
  fundamental_2_ano = 7,
  fundamental_3_ano = 16
}
